<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-3 mt-3">
        <li>
          <router-link to="/setup/cataloge-mapping/sales" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.SalesCatalogueName") }}: {{ $route.params.name }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
        <div class="dual-listbox-wrapper">
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.AvailableUsers") }}
                  </h6>
                  <input
                    v-model="searchSource"
                    :placeholder="$t('setup.label.Search')"
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <ul class="listbox-body">
                  <li
                    v-for="plan in filteredSourcePlans"
                    :key="plan.id"
                    :class="[
                      'listbox-item',
                      selectedSourcePlans === plan.id ? 'active' : '',
                    ]"
                    @click="selectedSourcePlans = plan.id"
                  >
                      {{ plan.username }}
                  </li>
                </ul>
              </div>
        
              <div class="arrow-buttons">
                <button
                  class="arrow-button"
                  :disabled="!selectedSourcePlans"
                  @click="moveToTarget"
                >
                  <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
                </button>
                <button
                  class="arrow-button"
                  :disabled="!selectedTargetPlans"
                  @click="moveToSource"
                >
                  <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                </button>
              </div>
        
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.SelectedUsers") }}
                  </h6>
                  <input
                    v-model="searchTarget"
                    :placeholder="$t('setup.label.Search')"
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <ul class="listbox-body">
                  <li
                    v-for="plan in filteredTargetPlans"
                    :key="plan.id"
                    :class="[
                      'listbox-item',
                      selectedTargetPlans === plan.id ? 'active' : '',
                    ]"
                    @click="selectedTargetPlans = plan.id"
                  >
                      {{ plan.username }}
                  </li>
                </ul>
              </div>
            </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            v-if="isEditMode"
            class="mr-3 mb-2 footerButton-next"
            @click="createsalescataloge"
            >{{ $t("setup.label.Update") }}</vs-button
          >
          <vs-button
            v-else
            class="mr-3 mb-2 footerButton-next"
            @click="createsalescataloge"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      warningPopup: false,
      isEditMode: false,
      warningText: "",
      plansInit: {},
      errorMessage: "",
      selectedSourcePlans: null,
      selectedTargetPlans: null,
      searchSource: "",
      id:"",
      searchTarget: "",
      userId:[],
      salesCatalogeDetails: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.catalogueMapping.CreateViewUserCataloge,
      selectedUserCatalogue: (state) => state.catalogueMapping.viewUserCatalogeList,
    }),
    filteredSourcePlans() {
      if (this.plansInit && this.plansInit.sourcePlans) {
        return this.plansInit.sourcePlans.filter(
          (d) =>
            d.username.toLowerCase().includes(this.searchSource.toLowerCase())
        );
      } else {
        return null;
      }
    },
    filteredTargetPlans() {
      if (this.plansInit && this.plansInit.targetPlans) {
        return this.plansInit.targetPlans.filter(
          (d) =>
            d.username.toLowerCase().includes(this.searchTarget.toLowerCase())
        );
      } else {
        return null;
      }
    },
  },
  methods: {
    moveToTarget() {
      if (!this.selectedSourcePlans) return;

      const selectedPlan = this.plansInit.sourcePlans.find(
        (discount) => discount.id === this.selectedSourcePlans
      );

      if (selectedPlan) {
        this.plansInit.targetPlans.push(selectedPlan);
        this.plansInit.sourcePlans =
          this.plansInit.sourcePlans.filter(
            (discount) => discount.id !== this.selectedSourcePlans
          );
        this.selectedSourcePlans = null;
      }
    },

    moveToSource() {
      if (!this.selectedTargetPlans) return;

      const selectedPlan = this.plansInit.targetPlans.find(
        (discount) => discount.id === this.selectedTargetPlans
      );

      if (selectedPlan) {
        this.plansInit.sourcePlans.push(selectedPlan);
        this.plansInit.targetPlans =
          this.plansInit.targetPlans.filter(
            (discount) => discount.id !== this.selectedTargetPlans
          );
        this.selectedTargetPlans = null;
      }
    },
    initializePlans() {
      const allUsers = (this.ReportsData && this.ReportsData.appUserDatas) || [];
      const selectedUsers = this.selectedUserCatalogue ? [...this.selectedUserCatalogue] : [];

      if (selectedUsers.length > 0) {
        const selectedPlanIds = selectedUsers.map(plan => plan.userId);
        
        const targetPlans = allUsers.filter(plan =>
          selectedPlanIds.includes(plan.id)
        );

        const sourcePlans = allUsers.filter(plan =>
          !selectedPlanIds.includes(plan.id)
        );

          this.$set(this, "plansInit", {
            sourcePlans,
            targetPlans,
          });
        } else {
          this.$set(this, "plansInit", {
            sourcePlans: [...allUsers],
            targetPlans: [],
          });
        }

      this.selectedSourcePlans = null;
      this.selectedTargetPlans = null;
    },
    async getAvailableUsers() {
      this.id = this.$route.params.id;
      try {
        await this.$store.dispatch(
          "catalogueMapping/setviewUserCataloge",
          this.id
        );
        this.isEditMode = this.selectedUserCatalogue && this.selectedUserCatalogue.length > 0;
        this.initializePlans();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createsalescataloge() {
        try {
        const selectedPlanIds = this.plansInit.targetPlans.map(plan => plan.id);
          const payload={
            locale: "en",
            usersCatalogeDetails: selectedPlanIds,
            catalogeId: this.$route.params.id,
          }
          if (this.isEditMode) {
            await this.$store.dispatch("catalogueMapping/updateUserCatalogeAction", {
            id: this.id,
            data: payload,
          });
          } else {
            await this.$store.dispatch("catalogueMapping/createUsercatalogeAction", payload);
          }
          this.$swal({
            title: "Success",
            icon: "success",
            text: this.isEditMode ? "Sales Catalogue Updated Successfully!" : "Sales Catalogue Created Successfully!",
            type: "success",
          });
          this.$router.push(`/setup/cataloge-mapping/sales`);
          this.resetForm();
        } catch (e) {
          this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
            "The parameter",
            ""
          );
          this.warningPopup = true;
          this.errors = e.message.errors;
        }
    },
    async getSalesCatalogeMappingTemplate() {
      try {
        await this.$store.dispatch(
          "catalogueMapping/setUserCatalogeMappingTemplate"
        );
        // this.initializePlans();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push("/setup/cataloge-mapping/sales");
    },
  },
  watch: {},
  created() {},
  async mounted() {
    await this.getSalesCatalogeMappingTemplate();
    await this.getAvailableUsers();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}
.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}
.listbox-header {
  background-color: #2e68b266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}
.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.listbox-item:hover {
  background-color: #f0f8ff;
}
.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}
.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}
.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
